import script from "./Component-04.vue?vue&type=script&setup=true&lang=js"
export * from "./Component-04.vue?vue&type=script&setup=true&lang=js"

import "./Component-04.vue?vue&type=style&index=0&id=06f8d09e&lang=scss"

const __exports__ = script;

export default __exports__